import {
    HStack,
    Tag,
    TagLabel,
    Text,
    Tooltip,
    Grid,
    GridItem,
    Button,
    Icon,
    IconButton,
    Box,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { formatDateDisplay } from "../../utils/displayGetters";
import { HiOutlineClipboardList } from "react-icons/hi";
import { useReactiveVar } from "@apollo/client";
import { userDetailsVar } from "../../lib/cache";


// Agnostic card component
interface ListCardProps {
    id: string;
    name: string;
    startDate?: string;
    endDate?: string;
    status?: boolean;
    additionalTagsAll?: string[];
    additionalTagsStaff?: string[];
}

export const ListCard = ({
    id, name, startDate, endDate, status, additionalTagsAll, additionalTagsStaff
}: ListCardProps) => {
    const currentUser = useReactiveVar(userDetailsVar);

    return (
      <Tooltip
        label={name}
        placement="top-start" // or try other placements
        openDelay={800}
        bg="text.dark"
        p={2}
      >
        <Box
          bg={"white"}
          borderRadius={"1px"}
          px={[2, null, null, 6, null]}
          py={[2, null, null, 4, null]}
          overflow={"hidden"}
        >
          <Grid templateColumns={"repeat(8, 1fr)"} w={"100%"}>
            <GridItem colSpan={5} maxW={"95%"}>
              <Link to={`${id}`}>
                <Text
                  fontWeight={"bold"}
                  fontSize={["md", null, null, "lg", null]}
                  isTruncated
                  _hover={{
                    color: "primary.dark",
                  }}
                  _active={{
                    color: "primary.darker",
                  }}
                >
                  {name}
                </Text>
              </Link>
              <HStack spacing={2} gridRow={1}>
                {startDate && (
                    <>
                        <Text fontSize={["xs", null, null, "md", null]}>
                            {formatDateDisplay(startDate)}
                        </Text>
                        <span>&ndash;</span>{" "}
                        <Text fontSize={["xs", null, null, "md", null]}>
                            {endDate ? formatDateDisplay(endDate) : "TBD"}
                        </Text>
                    </>
                )}
                {status !== undefined && (
                    <Tag
                        size={"sm"}
                        bg={status ? "activeSegment" : "inactiveSegment"}
                        borderRadius={"full"}
                        px={3}
                    >
                    <TagLabel>{status ? "Active" : "Inactive"}</TagLabel>
                    </Tag>
                )}
                {additionalTagsAll?.map((tag, ix) => (
                    <Text key={ix} color={"muted"} fontSize={"sm"}>
                        {tag}
                    </Text>
                ))}
                {currentUser?.isStaff && additionalTagsStaff?.map((tag, ix) => (
                    <Text key={ix} color={"muted"} fontSize={"sm"}>
                        {tag}
                    </Text>
                ))}
              </HStack>
            </GridItem>
            <GridItem colSpan={3}>
              <HStack align={"center"} justify={"flex-end"}>
                <Link to={`${id}`}>
                  <IconButton
                    aria-label={"link to segment summary"}
                    icon={<HiOutlineClipboardList />}
                    variant={"unStyled"}
                    display={["flex", null, "none", null, null]}
                  />
                  <Button
                    variant={"unStyled"}
                    fontSize={["sm", null, null, "md", null]}
                    display={["none", null, "flex", null, null]}
                    leftIcon={
                      <Icon
                        as={HiOutlineClipboardList}
                        w={[4, null, null, 5, null]}
                        h={[4, null, null, 5, null]}
                      />
                    }
                  >
                    Summary
                  </Button>
                </Link>
              </HStack>
            </GridItem>
          </Grid>
        </Box>
      </Tooltip>
    );
}
